export class TableDataQualitySettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "freshnessSloSeconds",
            "baseName": "freshnessSloSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "primaryKeyColumn",
            "baseName": "primaryKeyColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "uniquenessSloPercent",
            "baseName": "uniquenessSloPercent",
            "type": "number",
            "format": "double"
        },
        {
            "name": "criticalColumns",
            "baseName": "criticalColumns",
            "type": "Array<CriticalColumnSlo>",
            "format": ""
        },
        {
            "name": "alertRouting",
            "baseName": "alertRouting",
            "type": "DataQualityAlertRouting",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return TableDataQualitySettings.attributeTypeMap;
    }
    constructor() {
    }
}
